// TODO (Noah, 2024-10-09): Re-enable this rule
/* eslint-disable replo/consistent-component-exports */
import type {
  Flow,
  FlowInstance,
  FlowSlug,
  FlowStep,
} from "schemas/generated/flow";

import * as React from "react";

type ReploFlowsContextValue = {
  currentFlow: Flow | null;
  currentInstance: FlowInstance | null;
  nextStep: FlowStep | null;
  debug: {
    flowToDebug: FlowSlug | null;
    setFlowToDebug: React.Dispatch<
      React.SetStateAction<FlowSlug | null>
    > | null;
  };
};

export const ReploFlowsContext = React.createContext<ReploFlowsContextValue>({
  currentFlow: null,
  currentInstance: null,
  nextStep: null,
  debug: {
    flowToDebug: null,
    setFlowToDebug: null,
  },
});

export function useReploFlowsContext() {
  return React.useContext(ReploFlowsContext);
}
